// Der Server liefert Zeitpunkte in UTC ohne Zeitzone ("2026-10-07T12:00:00")
const alsDatum = (wert) => {
  if (!wert) return null;
  const text = String(wert);
  const d = new Date(/T/.test(text) && !/[zZ]|[+-]\d\d:?\d\d$/.test(text) ? `${text}Z` : text);
  return Number.isNaN(d.getTime()) ? null : d;
};

// Reines Datum ("2026-10-19") ohne Zeitzonen-Verschiebung
export function datum(wert, leer = '–') {
  if (!wert) return leer;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(wert));
  if (m && String(wert).length === 10) return `${m[3]}.${m[2]}.${m[1]}`;
  const d = alsDatum(wert);
  return d ? d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }) : leer;
}

export function zeitpunkt(wert, leer = '–') {
  const d = alsDatum(wert);
  return d ? d.toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : leer;
}

export function seit(wert, jetzt = new Date()) {
  const d = alsDatum(wert);
  if (!d) return '–';
  const min = Math.max(0, Math.round((jetzt - d) / 60000));
  if (min < 1) return 'gerade eben';
  if (min < 60) return `vor ${min} Min.`;
  const std = Math.round(min / 60);
  if (std < 48) return `vor ${std} Std.`;
  const tage = Math.round(std / 24);
  if (tage < 60) return `vor ${tage} Tagen`;
  return `vor ${Math.round(tage / 30)} Monaten`;
}

export function groesse(bytes) {
  if (bytes == null) return '–';
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${Math.round(bytes / (1024 * 1024))} MB`;
}

// ISO-Datum (yyyy-mm-dd) in lokaler Zeit, ohne den UTC-Sprung von toISOString()
export function isoDatum(d) {
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

// Verlaengern rechnet ab dem bisherigen Ablauf, bei abgelaufenen Lizenzen ab heute
export function verlaengertUm(gueltigBis, monate, heute = new Date()) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(gueltigBis || ''));
  const bisher = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
  const start = bisher && bisher > heute ? bisher : new Date(heute.getFullYear(), heute.getMonth(), heute.getDate());
  const ziel = new Date(start.getFullYear(), start.getMonth() + monate, start.getDate());
  // 31.01. + 1 Monat soll der 28./29.02. sein, nicht der 03.03.
  if (ziel.getDate() !== start.getDate()) ziel.setDate(0);
  return isoDatum(ziel);
}

export const STATUS = {
  aktiv: { text: 'Aktiv', farbe: 'success' },
  laeuft_bald_ab: { text: 'Läuft bald ab', farbe: 'warning' },
  abgelaufen: { text: 'Abgelaufen', farbe: 'error' },
  gesperrt: { text: 'Gesperrt', farbe: 'error' },
  nicht_aktiviert: { text: 'Nicht aktiviert', farbe: 'default' },
  ohne_bindung: { text: 'Ohne Gerätebindung', farbe: 'info' },
};

export function statusText(status, tage) {
  if (status === 'laeuft_bald_ab' && tage != null) {
    if (tage === 0) return 'Läuft heute ab';
    return tage === 1 ? 'Läuft morgen ab' : `Läuft in ${tage} Tagen ab`;
  }
  return STATUS[status]?.text || status || '–';
}

export const MODUS = { server: 'Netzwerk-Server', einzelplatz: 'Einzelplatz', netzwerk_server: 'Netzwerk-Server' };

export const fehlertext = (err, ersatz = 'Das hat nicht geklappt.') => {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d) && d[0]?.msg) return d.map((x) => x.msg).join(' · ');
  return err?.message === 'Network Error' ? 'Keine Verbindung zum Portal.' : ersatz;
};
